import API from "./API"

export const fetchAgtPerformance = () => API.get("agt-performance")
export const fetchAgtSummary = () => API.get("agt-summary")
